<template>
  <p style="text-align: center; margin-top: 100px">
    {{ C('dataIsEmpty') }}
  </p>
</template>

<script>
export default {}
</script>
<style></style>
